// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-1AxHn";
var _3 = "backBatton-bFAYj";
var _4 = "title-2f2lc";
export { _1 as "__esModule", _2 as "header", _3 as "backBatton", _4 as "title" }
export default { "__esModule": _1, "header": _2, "backBatton": _3, "title": _4 }
